import React from 'react'
import PropTypes from 'prop-types';
import { Modal } from 'bootstrap';

class BootstrapModal extends React.Component {
  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
    this.uuid = this.generateUuid();
    this.bsModal = null
  }

  componentDidMount() {
    this.bsModal = new Modal(this.modalRef.current, {
      backdrop: 'static',
      keyboard: false
    })
    this.bsModal.show()

    if (this.props.handleHide) {
      this.modalRef.current.addEventListener('hidden.bs.modal', this.props.handleHide)
    }
  }

  componentWillUnmount() {
    if (this.bsModal) {
      this.bsModal.hide()
      this.bsModal.dispose()
    }
    if (this.props.handleHide) {
      this.modalRef.current.removeEventListener('hidden.bs.modal', this.props.handleHide)
    }
  }

  handleClickThenHide = (onClick) => (event) => {
    Promise.resolve(onClick()).then(() => {
      if (this.bsModal) this.bsModal.hide()
    })
  }

  generateButtons = () => {
    return this.props.buttons.map((button, i) => {
      if(React.isValidElement(button)) {
        return React.cloneElement(button, { key: i })
      } else {
        const { name, onClick, dismiss, loading, hideAfterClicking = true, ...buttonProps } = button

        const buttonText = loading ?
          <span>
            <i className="fa fa-spinner fa-spin fa-fw" aria-hidden="true">
            </i> { name }
          </span>
        :
          name

        if (dismiss) {
          return (
            <button
              { ...buttonProps } 
              key={ i } 
              onClick={ () => {
                if (onClick) onClick();
                if (this.bsModal) this.bsModal.hide();
              }} 
            >
              { buttonText }
            </button>
          )
        } else {
          return (
            <button
              { ...buttonProps }
              key={ i }
              onClick={ hideAfterClicking ? this.handleClickThenHide(onClick) : onClick }
            >
              { buttonText }
            </button>
          )
        }
      }
    })
  }

  render() {
    const uuid = this.uuid;

    return (
      <div className="modal fade" id={ `${uuid}_modal` } tabIndex="-1" role="dialog"
                          aria-labelledby={ `${uuid}_modal_label` }
                          data-backdrop="static"
                          data-keyboard="false"
                          ref={this.modalRef}>

        <div className="modal-dialog" role="document">

          <div className="modal-content">
            <div className="modal-header">

              <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <h4 className="modal-title" id={ `${uuid}_modal_label` }>{ this.props.title }</h4>
            </div>

            <div className="modal-body">
              { this.props.children }
            </div>

            {
              this.props.buttons.length > 0 &&
                <div className="modal-footer">
                  { this.generateButtons() }
                </div>
            }
          </div>
        </div>
      </div>
    )
  }

  generateUuid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r&0x3 | 0x8);
      return v.toString(16);
    });
  }
}

BootstrapModal.defaultProps = {
  buttons: []
}

BootstrapModal.propTypes = {
  title:           PropTypes.string.isRequired,
  handleHide:      PropTypes.func,
  buttons:         PropTypes.arrayOf(PropTypes.object)
}

export default BootstrapModal;
